import React from 'react'
import { DownIcon } from '../../icons'

export const LoadingIndicator = () => {
  return <div className="algolia-search-loading-indicator"></div>
}

const SearchUiViewButton = ({
  uiType,
  activeView,
  results,
  changeView,
  label,
}) => {
  return (
    <li
      className={`${uiType}-type ${activeView === uiType ? `active` : ``} ${
        results < 1 ? `inactive` : ``
      }`}
      onClick={() => changeView(uiType)}
    >
      {label}
    </li>
  )
}

export const SearchUiViewButtonList = ({
  dropdown,
  toggleDropdown,
  viewTitle,
  changeView,
  view,
  productResults,
  articleResults,
}) => {
  const buttonClasses =
    `search-view__mobile-toggle small-show search-type wide text-left`
  return (
    <div className="search-view search-view__wrapper">
      <button
        className={`${buttonClasses} ${
          dropdown === `searchTypes` ? `active` : ``
        }`}
        onClick={() => toggleDropdown(`searchTypes`)}
      >
        {viewTitle} <DownIcon />
      </button>
      <ul
        className={`search-view__item-list  small-slide-down ${
          dropdown === `searchTypes` ? `visible` : ``
        }`}
      >
        <SearchUiViewButton
          uiType="product"
          activeView={view}
          changeView={changeView}
          label={`Products (${productResults})`}
          results={productResults}
        />
        <SearchUiViewButton
          uiType="article"
          activeView={view}
          changeView={changeView}
          label={`Resources (${articleResults})`}
          results={articleResults}
        />
      </ul>
    </div>
  )
}
